// extracted by mini-css-extract-plugin
module.exports = {"starterKit":"starterKit2_starterKit__NZDw3"};